import { render, staticRenderFns } from "./SocialData.vue?vue&type=template&id=60c2a1df&scoped=true"
import script from "./SocialData.vue?vue&type=script&lang=js"
export * from "./SocialData.vue?vue&type=script&lang=js"
import style0 from "./SocialData.vue?vue&type=style&index=0&id=60c2a1df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2a1df",
  null
  
)

export default component.exports